import { render, staticRenderFns } from "./Mdgs.vue?vue&type=template&id=66bae289&scoped=true"
import script from "./Mdgs.vue?vue&type=script&lang=js"
export * from "./Mdgs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bae289",
  null
  
)

export default component.exports